export type EventDetails = {
    id: number;
    name: string;
    date: string;
    time: string;
    location?: string;
    description: string;
};

export type EventProduct = {
    id: number;
    url: string;
    name: string;
    main_image?: string;
    recommended_level?: string;
};

export type Event = {
    event_details: EventDetails;
    product: EventProduct;
}

export const processEvents = (events: Event[]) => {
    const grouped = events.reduce((accumulator, currentEvent) => {
        const dateKey = currentEvent.event_details.date;

        if (!accumulator[dateKey]) {
            accumulator[dateKey] = [];
        }

        accumulator[dateKey].push(currentEvent);

        return accumulator;
    }, {} as Record<string, Event[]>);

    for (const date in grouped) {
        grouped[date].sort((a: Event, b: Event) => {
            return a.event_details.time.localeCompare(b.event_details.time);
        });
    }

    return grouped;
}

export type IsoDate = `${number}-${number}-${number}`;

function startOfDay(date: Date): Date {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);

  return d;
}

function pad2(n: number): string {
  return String(n).padStart(2, "0");
}

export function toIso(date: Date): IsoDate {
  const d = startOfDay(date);
  const fullYear = d.getFullYear();
  const month = pad2(d.getMonth() + 1);
  const day = pad2(d.getDate());

  return `${fullYear}-${month}-${day}` as IsoDate;
}

export function fromIso(iso: string): Date {
  const cleanIso = iso.split('T')[0];
  const [fullYear, month, day] = cleanIso.split("-").map(Number);

  return new Date(fullYear, month - 1, day);
}

export function addDays(date: Date, days: number): Date {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + days);
  
  return newDate;
}

export const formatters = {
    monthYear: new Intl.DateTimeFormat('en-GB', { month: 'long', year: 'numeric' }),
    dayDate: new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: 'long' }),
    weekdayShort: new Intl.DateTimeFormat('en-GB', { weekday: 'short' }),
};